import { c as _c } from "react/compiler-runtime";
import { useRef, useEffect } from 'react';
import { m, animate, useInView, useTransform, useMotionValue } from 'framer-motion';
import Typography from '@mui/material/Typography';

// ----------------------------------------------------------------------

export function AnimateCountUp(t0) {
  const $ = _c(37);
  let other;
  let sx;
  let t1;
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  let to;
  let unitProp;
  if ($[0] !== t0) {
    ({
      to,
      from: t1,
      toFixed: t2,
      once: t3,
      duration: t4,
      amount: t5,
      unit: unitProp,
      component: t6,
      sx,
      ...other
    } = t0);
    $[0] = t0;
    $[1] = other;
    $[2] = sx;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
    $[8] = t6;
    $[9] = to;
    $[10] = unitProp;
  } else {
    other = $[1];
    sx = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
    t5 = $[7];
    t6 = $[8];
    to = $[9];
    unitProp = $[10];
  }
  const from = t1 === undefined ? 0 : t1;
  const toFixed = t2 === undefined ? 0 : t2;
  const once = t3 === undefined ? true : t3;
  const duration = t4 === undefined ? 2 : t4;
  const amount = t5 === undefined ? 0.5 : t5;
  const component = t6 === undefined ? "p" : t6;
  const countRef = useRef(null);
  let t7;
  if ($[11] !== to) {
    t7 = shortenNumber(to);
    $[11] = to;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  const shortNumber = t7;
  const startCount = useMotionValue(from);
  const unit = unitProp ?? shortNumber?.unit;
  const endCount = shortNumber ? shortNumber.value : to;
  let t8;
  if ($[13] !== amount || $[14] !== once) {
    t8 = {
      once,
      amount
    };
    $[13] = amount;
    $[14] = once;
    $[15] = t8;
  } else {
    t8 = $[15];
  }
  const inView = useInView(countRef, t8);
  let t9;
  if ($[16] !== toFixed) {
    t9 = latest => latest.toFixed(isFloat(latest) ? toFixed : 0);
    $[16] = toFixed;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  const rounded = useTransform(startCount, t9);
  let t10;
  let t11;
  if ($[18] !== duration || $[19] !== endCount || $[20] !== inView || $[21] !== startCount) {
    t10 = () => {
      if (inView) {
        animate(startCount, endCount, {
          duration
        });
      }
    };
    t11 = [duration, endCount, inView, startCount];
    $[18] = duration;
    $[19] = endCount;
    $[20] = inView;
    $[21] = startCount;
    $[22] = t10;
    $[23] = t11;
  } else {
    t10 = $[22];
    t11 = $[23];
  }
  useEffect(t10, t11);
  let t12;
  if ($[24] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      p: 0,
      m: 0,
      display: "inline-flex"
    };
    $[24] = t12;
  } else {
    t12 = $[24];
  }
  let t13;
  if ($[25] !== sx) {
    t13 = Array.isArray(sx) ? sx : [sx];
    $[25] = sx;
    $[26] = t13;
  } else {
    t13 = $[26];
  }
  let t14;
  if ($[27] !== t13) {
    t14 = [t12, ...t13];
    $[27] = t13;
    $[28] = t14;
  } else {
    t14 = $[28];
  }
  let t15;
  if ($[29] !== rounded) {
    t15 = <m.span ref={countRef}>{rounded}</m.span>;
    $[29] = rounded;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== component || $[32] !== other || $[33] !== t14 || $[34] !== t15 || $[35] !== unit) {
    t16 = <Typography component={component} sx={t14} {...other}>{t15}{unit}</Typography>;
    $[31] = component;
    $[32] = other;
    $[33] = t14;
    $[34] = t15;
    $[35] = unit;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  return t16;
}
function isFloat(n) {
  return typeof n === 'number' && !Number.isInteger(n);
}
function shortenNumber(value) {
  if (value >= 1e9) {
    return {
      unit: 'b',
      value: value / 1e9
    };
  }
  if (value >= 1e6) {
    return {
      unit: 'm',
      value: value / 1e6
    };
  }
  if (value >= 1e3) {
    return {
      unit: 'k',
      value: value / 1e3
    };
  }
  return undefined;
}